import { gameStateClient } from "@/config/game-state-client";

/**
 * Short-lived (120 s) grant to open win-game-service's live websocket for a
 * game. Only the WIN API serves this route, so it is not in the generated
 * wgs-client.
 */
export interface StreamGrant {
  /** Signed HS256 JWT. */
  grant: string;
  /** Websocket URL to dial, with the grant already in its query string. */
  url: string;
  /** RFC 3339 timestamp after which the grant is rejected. */
  expiresAt: string;
}

export const postStreamGrant = async (gameId: string): Promise<StreamGrant> => {
  const { data, error } = await gameStateClient.post<StreamGrant, unknown>({
    url: "/game-state/games/{gameId}/stream-grant",
    path: { gameId },
  });
  if (error || !data) {
    throw error ?? new Error("empty stream grant response");
  }
  return data;
};
